enum ChoiceGroupFieldActionType {
    DISPLAY_CHOICE_GROUP_FIELD_ERROR = "DISPLAY_CHOICEGROUP_FIELD_ERROR",
    UPDATE_CHOICE_GROUP_FIELD_VALUE = "UPDATE_CHOICEGROUP_FIELD_VALUE",
    RESET_CHOICE_GROUP_FIELD = "RESET_CHOICEGROUP_FIELD",
}

export default ChoiceGroupFieldActionType;